import React, { useEffect, useRef, useState } from 'react';

const BrainImpactSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="py-32 bg-white relative overflow-hidden"
    >
      {/* Background Image */}
      {/* <div className="absolute inset-0 opacity-5">
        <img 
          src="https://images.unsplash.com/photo-1511895426328-dc8714191300?w=1200&q=80" 
          alt=""
          className="w-full h-full object-cover"
        />
      </div> */}

      <div className="max-w-6xl mx-auto px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span className={`inline-block text-sm text-[#202020]/40 uppercase tracking-widest mb-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            Science & Research
          </span>
          <h2 className={`text-3xl md:text-4xl lg:text-5xl font-normal text-[#202020] tracking-tight transition-all duration-1000 delay-150 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            How does Contemplation impact your brain?
          </h2>
          <p className={`text-lg text-[#202020]/70 max-w-4xl mx-auto mt-6 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            Dr Antonio Ocana, MD, a senior psychotherapist specializing in addiction, trauma, ADHD and other serious mental health conditions, and Tarun Gulati, Founder of Contemplate, discuss the scientific aspects of Contemplation and how it affects your brain.
          </p>
        </div>

        {/* Video Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Video 1 */}
          <div className={`transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl bg-[#202020] aspect-video">
              <iframe
                src="https://www.youtube.com/embed/Iu9qWYwxvSw"
                title="Contemplation and Brain Impact - Discussion with Dr Antonio Ocana and Tarun Gulati"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full"
              />
            </div>
          </div>

          {/* Video 2 */}
          <div className={`transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl bg-[#202020] aspect-video">
              <iframe
                src="https://www.youtube.com/embed/3aj4UrWGTdI"
                title="Contemplation and Brain Impact - Discussion with Dr Antonio Ocana and Tarun Gulati"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrainImpactSection;

